import { ArrowDownDropCircleOutlineIcon } from './ArrowDownDropCircleOutlineIcon';

/**
 * author: Austin Andrews
 * id 65BE2EE5-23A5-49F8-A7A2-AEDD25C9C661
 * name arrow-down-drop-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-drop-circle-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomDropCircleOutlineIcon = ArrowDownDropCircleOutlineIcon;
export default ArrowBottomDropCircleOutlineIcon